import { createResponsiveStateReducer } from "redux-responsive";
import { createSelector } from "reselect";
import { equals, path, prop } from "ramda";
import breakpoints from "~/constants/breakpoints";

const getBrowser = path(["application", "browser"]);

const selectLessThan = createSelector(getBrowser, prop("lessThan"));

const selectGreaterThan = createSelector(getBrowser, prop("greaterThan"));

const selectIs = createSelector(getBrowser, prop("is"));

export const selectMediaType = createSelector(getBrowser, prop("mediaType"));

export const selectOrientation = createSelector(
  getBrowser,
  prop("orientation")
);

export const selectIsPortrait = createSelector(
  selectOrientation,
  equals("portrait")
);

export const selectIsLandscape = createSelector(
  selectOrientation,
  equals("landscape")
);

export const selectIsLessThanSmall = createSelector(
  selectLessThan,
  prop("small")
);

export const selectIsLessThanMedium = createSelector(
  selectLessThan,
  prop("medium")
);

export const selectIsLessThanLarge = createSelector(
  selectLessThan,
  prop("large")
);

export const selectIsGreaterThanSmall = createSelector(
  selectGreaterThan,
  prop("small")
);

export const selectIsGreaterThanMedium = createSelector(
  selectGreaterThan,
  prop("medium")
);

export const selectIsGreaterThanLarge = createSelector(
  selectGreaterThan,
  prop("large")
);

export const selectIsSmall = createSelector(selectIs, prop("small"));

export const selectIsMedium = createSelector(selectIs, prop("medium"));

export const selectIsLarge = createSelector(selectIs, prop("large"));

export default createResponsiveStateReducer(breakpoints);
